import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { IonicModule } from '@ionic/angular';
import { BugReportPopoverPage } from './bug-report-popover';

@NgModule({
  declarations: [
    BugReportPopoverPage,
  ],
  imports: [
    RouterModule,
    CommonModule,
    ReactiveFormsModule,
    IonicModule.forRoot(),
  ],
})
export class BugReportPopoverPageModule {}
